export const summaryRows: string[] = [
  'Volume 01 — Food Science & Technology Fundamentals: Food Composition, Quality & the Food Plant',
  'Volume 02 — Food Processing Unit Operations: Thermal Processing, Chilling & Freezing, Drying, Mixing & Packaging',
  'Volume 03 — Plant Hygiene & Sanitation: Hygienic Design, Cleaning & Disinfection and CIP Systems',
  'Volume 04 — Food Microbiology & Hazard Control: Pathogens, Spoilage and Biological, Chemical & Physical Hazards',
  'Volume 05 — Food Safety Systems: HACCP, Prerequisite Programs, Allergen Management, Traceability & Recall',
  'Volume 06 — Food Quality Control, Inspection, Audits & Continuous Improvement',
  'Bonus 1 — HACCP Step-by-Step Visual Guide',
  'Bonus 2 — Food Plant Sanitation & CIP Troubleshooting Guide',
  'Bonus 3 — Food Allergen Control Visual Guide',
  'Bonus 4 — Foreign Body Prevention Field Guide',
  'Bonus 5 — Food Processing & Food Safety Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
